import React           from 'react';
import PropTypes       from 'prop-types';
import CamShowsItem    from './CamShowsItem';
import { generateKey } from '../../utils/CommonUtils';

const SWIPE_THRESHOLD = 40;

class CamShowsFeatured extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      currentId: 0,
      items: this.getItems(),
      currentItem: this.getItems()[0],
      animation: false,
      reversed: false,
    };

    this.getItemClass = this.getItemClass.bind(this);
    this.initTimer    = this.initTimer.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onClickItem  = this.onClickItem.bind(this);
    this.onTouchEnd   = this.onTouchEnd.bind(this);
    this.onTouchStart = this.onTouchStart.bind(this);

    this.timer = null;
    this.timeOut = null;
    this.touchStart = null;
  }


  componentDidMount() {
    this.props.items.length > 1 && this.initTimer();
  }

  componentDidUpdate(prevProps) {
    if (JSON.stringify(prevProps.items) !== JSON.stringify(this.props.items)) {
      this.setState({items: this.getItems()});
    }
  }

  componentWillUnmount() {
    this.props.items.length > 1 && window.clearInterval(this.timer);
  }

  initTimer() {
    this.timer = window.setInterval(() => {
      const nextId = this.state.currentId === (this.state.items.length - 1) ? 0 : this.state.currentId + 1;
      const nextItem = this.state.items[nextId];
      this.setState({currentId: nextId, currentItem: nextItem, animation: true, reversed: false});
		}, 3000);
  }

  onMouseEnter() {
    if (this.props.items.length > 1) {
        window.clearInterval(this.timer);
        window.clearTimeout(this.timeOut);
    }
  }

  onMouseLeave() {
    if (this.props.items.length > 1) {
      this.timeOut = window.setTimeout(() => {
        const nextId   = this.state.currentId === (this.state.items.length - 1) ? 0 : this.state.currentId + 1;
        const nextItem = this.state.items[nextId];
        
        this.setState({currentId: nextId, currentItem: nextItem, animation: true}, () => {
              this.initTimer();
            });
        }, 1000);
      }
  }

  onTouchStart(e) {
    window.clearInterval(this.timer);
    window.clearTimeout(this.timeOut);
    this.touchStart = e.changedTouches[0].screenX;
  }

  onTouchEnd(e) {
    this.swipe(e.changedTouches[0].screenX);
  }

  swipe(touchEnd) {
    window.clearInterval(this.timer);
    window.clearTimeout(this.timeOut);
    if (this.touchStart > touchEnd + SWIPE_THRESHOLD) {
      //Show Next Item
      const nextId   = this.state.currentId === (this.state.items.length - 1) ? 0 : Math.abs(this.state.currentId + 1);
      const nextItem = this.state.items[nextId];

      this.setState({currentId: nextId, currentItem: nextItem, animation: true, reversed: false}, () => {
        this.initTimer();
      });
    } else if (this.touchStart < touchEnd - SWIPE_THRESHOLD) {
      //Show Last Item
      const lastId   = this.state.currentId === 0 ? this.state.items.length - 1 : Math.abs(this.state.currentId - 1);
      const lastItem = this.state.items[lastId];

      this.setState({currentId: lastId, currentItem: lastItem, animation: true, reversed: true}, () => {
        this.initTimer();
      });
    }
  }

  setItem(currentId, item) {
    item.index = currentId;
    this.setState({currentId, currentItem: item});
    
  }

  getItems() {
    let items = JSON.parse(JSON.stringify(this.props.items)); 
    items.unshift(items.pop());
    items = items.map((item, index) => ({...item, index: index}));
    // need minimum 4 or 1 tiles for a clean slider flow
    if (items.length === 3 || items.length === 2) {
      items =  [...items, ...items];
    }

    return items;
  }

  onClickItem(currentId) {
    const nextId   = currentId === 0 ?  (this.state.items.length - 1) : currentId - 1;
    this.setState({currentId: nextId, currentItem: this.state.items[nextId]});
  }

  isPrimary(index) {
    const current = this.state.currentId;
    const items   = this.state.items;
    return (items.length > 0) && (items[index] && ((index - 1) === current)) || (index === (current - (items.length - 1)));
  }

  getItemClass(index) {
    const current = this.state.currentId;
    const items   = this.state.items;

    if(this.props.items.length === 1) {
      return 'single';
    }

    if (index === current) {
      return 'fourth';
    }

    if (this.isPrimary(index)) {
        return 'primary';
    }
   
    if ((items.length > 1) && (items[index] && ((index - 2) === current)) || (index === (current - (items.length - 2)))) {
        return 'secondary';
    }

    if (((items.length > 2) && (this.props.items.length > 2)) && ((items[index] && ((index - 3) === current)) || (index === (current - (items.length - 3))))) {
      return 'third';
    }
  
    return 'none';
  }

  render() {
    return (
      <div className={'cam-shows__featured' + (this.props.isModule ? ' cam-shows__featured--module' : '') + (this.state.animation ? " cam-shows__featured--animation" : "") + (this.state.animation && this.state.reversed ? "__reversed" : "")} onTouchStart={this.onTouchStart} onTouchEnd={this.onTouchEnd}>
         {!this.props.isModule ? (this.props.isMobile ? <img className='cam-shows__header-image' src={"/assets/img/camshows/arrows_mobile.png"} /> : <img className='cam-shows__header-image' src={"/assets/img/camshows/arrows.png"} />) : null}
          {!this.props.isModule && <h2 className='cam-shows__featured-headline'>HIGHLIGHTS</h2>}
          <div className='cam-shows__featured-slider' onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
              { this.state.items.map((item, index) => <CamShowsItem key={generateKey('cam-shows-slider', index)} item={item} isFeatured={true} itemClass={this.getItemClass(index)} isMobile={this.props.isMobile} isModule={this.props.isModule} lazyImageLoading={this.props.lazyImageLoading} onCloseModal={this.props.onCloseModal} onClickItem={this.isPrimary(index) ? null : this.onClickItem}/>) }
              <div className='cam-shows__featured-slider__dots'>
                {
                  this.props.items.length > 1 && this.props.items.map((item, index) => (
                    <div key={generateKey('cam-shows-dot', index)} className={'cam-shows__featured-slider__dot' + ((index === this.state.currentItem.index) ? ' cam-shows__featured-slider__dot--active' : '')} onClick={() => this.setItem(index, item)}></div>
                  ))
                }
              </div>
          </div>
      </div>
    );
  }
}

CamShowsFeatured.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
      actorId:     PropTypes.number,
      actorName:   PropTypes.string,
      name:        PropTypes.string,
      actorAvatar: PropTypes.shape({
        url: PropTypes.string
      }),
      price:     PropTypes.shape({
          value:    PropTypes.number,
          currency: PropTypes.string,
          symbol:   PropTypes.string,
      }),
      actorLink: PropTypes.string,
      online:    PropTypes.bool,
      hasStarted:PropTypes.bool,
      featured:  PropTypes.bool,
      imageUrl:  PropTypes.string,
      start:     PropTypes.string,
      end:       PropTypes.string,
      bonusCode: PropTypes.string,
      occurence: PropTypes.number,
      count:     PropTypes.number,
      ump: PropTypes.shape({
        url: PropTypes.string,
        aspectRatio: PropTypes.string,
      }),
    })),
    isMobile:         PropTypes.bool,
    isModule:         PropTypes.bool,
    lazyImageLoading: PropTypes.bool,
    onCloseModal:     PropTypes.func,
};

export default CamShowsFeatured;
